import { Clock, MapPin, Navigation } from "lucide-react";
import { SITE } from "../data/site";

export const OutletCard = ({ location, detailed = false }) => (
  <article
    data-testid={`outlet-card-${location.id}`}
    className="flex h-full flex-col rounded-lg border border-amber-900/15 bg-white shadow-[0_18px_50px_-24px_rgba(120,72,10,0.35)]"
  >
    <div className="flex-1 px-6 pb-6 pt-7 sm:px-8">
      <span className="inline-block rounded-full bg-charcoal px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-bumbu-bright">
        {location.badge}
      </span>
      <h3 className="mt-4 font-heading text-xl font-extrabold tracking-tight text-charcoal sm:text-2xl">
        {location.name}
      </h3>

      <p className="mt-4 flex items-start gap-2.5 text-sm leading-relaxed text-charcoal-muted">
        <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-bumbu" aria-hidden="true" />
        {location.address}
      </p>

      <div className="mt-5 space-y-2">
        {location.hours.map((h) => (
          <p key={h.days} className="flex items-start gap-2.5 text-sm text-charcoal-muted">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-bumbu" aria-hidden="true" />
            <span>
              <span className="font-bold text-charcoal">{h.days}:</span> {h.time}
            </span>
          </p>
        ))}
      </div>

      <p className="mt-5 text-sm leading-relaxed text-charcoal-muted">{location.note}</p>

      {detailed && location.facilities && (
        <ul className="mt-5 flex flex-wrap gap-2" aria-label="Fasilitas">
          {location.facilities.map((f) => (
            <li
              key={f}
              className="rounded-full border border-amber-900/20 bg-canvas-subtle px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-wider text-charcoal-muted"
            >
              {f}
            </li>
          ))}
        </ul>
      )}
    </div>

    <div className="px-6 pb-6 sm:px-8">
      <div className="ticket-perf" aria-hidden="true" />
      <div className="flex flex-wrap gap-3 pt-6">
        <a
          href={location.maps}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`directions-link-${location.id}`}
          className="inline-flex items-center gap-2 rounded-full bg-charcoal px-5 py-2.5 font-heading text-sm font-bold text-canvas transition-all hover:scale-[1.03] hover:bg-bumbu hover:text-charcoal active:scale-[0.98]"
        >
          <Navigation className="h-4 w-4" aria-hidden="true" />
          Petunjuk Arah
        </a>
        {location.grabfood && (
          <a
            href={SITE.grabfood}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`grabfood-link-${location.id}`}
            className="inline-flex items-center gap-2 rounded-full border-2 border-goang px-5 py-2.5 font-heading text-sm font-bold text-goang-deep transition-all hover:scale-[1.03] hover:bg-goang hover:text-white active:scale-[0.98]"
          >
            Pesan GrabFood
          </a>
        )}
      </div>
    </div>
  </article>
);
